const premadeAppNames: { [key: string]: string } = {
  BABYLON: 'babylon',
  BABYLON_US: 'babylon_us',
  RWT: 'nhs-rwt',
  UHB: 'nhs-uhb-ed',
  RBFT: 'nhs-rbft',
  BABYLON_CANADA_B2G: 'babylon-canada-b2g',
}

export default premadeAppNames
